// Common Styles for the Application Details Feature
import styled from 'styled-components'

const colors = {
  gray: '#E0E0E0',
  lightGray: '#ddd',
  darkGray: 'gray',
  orange: ' #ce7019',
  borderColor: '#ccc',
  white: 'white',
  black: '#56565a'
}

// Table Wrapper Component
///////////////////////////////////////
const Table = styled.div`
  background-color: white;
  margin: 0 0 30px 0;
`
const Headers = styled.div`
  background-color: ${colors.gray};
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 8px;
  display: flex;
`
const Header = styled.span`
  font-weight: bold;
  line-height: 15px;
  width: ${props => props.width}%;
`
const Body = styled.div``
///////////////////////////////////////

// Row component
///////////////////////////////////////
const RowStyled = styled.div`
  padding: 8px;
  border-bottom: 1px dashed ${colors.lightGray};
  display: flex;
`
const Column = styled.div`
  width: ${props => props.width}%;
`
///////////////////////////////////////

// Editors
///////////////////////////////////////
const StaticContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const EditorContainer = styled.div`
`
const EditContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`
const ToggleBtn = styled.a`
  color: ${colors.orange};
  text-decoration: none;
  &:hover {
    cursor: pointer;
  }
`
const Form = styled.form`
  width: 90%;
`
const Input = styled.input`
  display: block;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid ${colors.borderColor};
  color: ${colors.black};
  margin-bottom: 5px;
  width: 90%;
`
const CheckboxContainer = styled.div`
  display: flex;
`
const Checkbox = styled.input`
  display: inline-block;
  margin-right: 10px !important;
`
const Textarea = styled.textarea`
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid ${colors.borderColor};
  width: 90%;
  color: ${colors.black};
`
const Submit = styled.button`
  padding: 5px 10px;
  background: ${colors.orange};
  border-radius: 4px;
  color: ${colors.white};
  &:disabled {
    background: ${colors.lightGray};
  }
`
///////////////////////////////////////

export {
  RowStyled,
  Column,
  StaticContainer,
  EditorContainer,
  EditContainerHeader,
  Table,
  Headers,
  Header,
  Body,
  ToggleBtn,
  Form,
  Input,
  Textarea,
  Checkbox,
  CheckboxContainer,
  Submit
}